module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M16 7.70361V24.2962' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M7.7037 16H24.2963' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E\""


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/plus.svg
// module id = 104
// module chunks = 0